var g = (B, x, f) => new Promise((C, L) => {
  var D = (e) => {
    try {
      u(f.next(e));
    } catch (p) {
      L(p);
    }
  }, m = (e) => {
    try {
      u(f.throw(e));
    } catch (p) {
      L(p);
    }
  }, u = (e) => e.done ? C(e.value) : Promise.resolve(e.value).then(D, m);
  u((f = f.apply(B, x)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import le from "./components/orderCycleItem.vue.js";
import ne from "../../com-components/delivery-details/deliveryDetails.vue.js";
import "../../com-components/delivery-details/deliveryDetails.vue2.js";
import { getDict as $ } from "@oppein/op-utils";
import { getDateDisabledFunction as de, validateDeliveryDate as F, REQUIRED_CYCLE_CATEGORIES as ce } from "./utils.js";
import { postQueryOrderStorageTimeByQry as ie } from "../../request/designapi/design/orderStorageTime/queryOrderStorageTimeByQry/post.js";
import { postFindCheckTypeList as ue } from "../../request/designapi/design/unified/findCheckTypeList/post.js";
import { postCheckByRule as ye } from "../../request/designapi/design/unifiedCheck/checkByRule/post.js";
import { defineComponent as fe, useTemplateRef as U, computed as S, onMounted as me, openBlock as y, createElementBlock as v, createElementVNode as i, createVNode as w, withCtx as h, createCommentVNode as A, Fragment as R, renderList as j, createTextVNode as K, createBlock as Q } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as pe } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as b, reactive as be, unref as I } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import De from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ge from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import { toDisplayString as T } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ve from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/date-picker/src/DatePicker.js";
import G from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import we from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Ie = { class: "tw:mb-3" }, Ce = { class: "tw:flex tw:items-center tw:mb-2" }, _e = { class: "tw:mr-8 tw:font-bold" }, he = {
  key: 0,
  style: { color: "red", display: "inline-block", margin: "0 10px" }
}, Le = {
  key: 1,
  class: "tw:text-xs tw:text-red-500 tw:font-medium tw:ml-1"
}, Oe = { class: "tw:max-h-[450px] tw:overflow-y-auto tw:mb-5" }, Te = { class: "tw:flex tw:items-center tw:py-2.5 tw:px-3 tw:bg-blue-50 tw:mb-3" }, xe = { class: "tw:font-bold" }, Ne = { class: "tw:ml-1 tw:inline-flex tw:items-center tw:justify-center tw:min-w-[16px] tw:h-[16px] tw:px-1 tw:rounded-full tw:border tw:border-red-500 tw:text-red-500 tw:text-xs tw:font-bold" }, ke = { class: "tw:flex tw:justify-center tw:gap-4" }, Je = /* @__PURE__ */ fe({
  __name: "OrderCycleContent",
  setup(B, { expose: x }) {
    const f = U("orderCycleContainer"), C = U("deliveryDetailsRef"), L = pe(), D = b(!1), m = b(!1), u = b(!1), e = be({
      pageMode: "edit",
      businessType: "ORDER_ID",
      cycleOrderList: [],
      totalStorageDayNumber: void 0,
      customerDeliveryDate: void 0,
      isNeedCycleCheck: !1,
      sourceKey: "",
      designerId: "",
      designerAccount: "",
      checkPoint: "caxa_onekey_ap_check"
      // 默认使用旧设计软件检查点
    }), p = b(3e3), P = b(!1), O = S(() => e.pageMode === "view"), E = b([]), V = b([]), Y = () => g(this, null, function* () {
      const [a, t] = yield Promise.all([$("ROOT_brand"), $("ROOT_category")]);
      E.value = a, V.value = t;
    });
    me(() => {
      Y();
    });
    const q = S(() => {
      if (!e.cycleOrderList || e.cycleOrderList.length === 0)
        return [];
      const a = /* @__PURE__ */ new Map();
      return e.cycleOrderList.forEach((r) => {
        const o = `${r.brand}|${r.category}` || "";
        a.has(o) || a.set(o, []), a.get(o).push(r);
      }), Array.from(a.entries()).map(([r, o]) => {
        var c, _, M, H;
        const [s, l] = r.split("|"), n = ((_ = (c = E.value) == null ? void 0 : c.find((k) => k.value === s)) == null ? void 0 : _.label) || s, d = ((H = (M = V.value) == null ? void 0 : M.find((k) => k.value === l)) == null ? void 0 : H.label) || l;
        return {
          brandCategory: r,
          brand: s,
          category: l,
          brandLabel: n,
          categoryLabel: d,
          items: o
        };
      });
    }), J = S(
      () => de(e.totalStorageDayNumber, 4)
    ), z = () => !F(e.customerDeliveryDate, e.totalStorageDayNumber, 4);
    function X() {
      var a, t;
      for (const r of e.cycleOrderList) {
        const o = ((a = r.orderData) == null ? void 0 : a.productCategory) || "", s = ((t = r.orderData) == null ? void 0 : t.old) === 1;
        let l = !1;
        if (!s && ((r.cupboardType === "customize" || ce.includes(o)) && (l = !0), l && (r.storageDayNumber === null || r.storageDayNumber === void 0)))
          return !1;
      }
      return !(e.businessType === "BATCH_ID" && !e.businessId && e.cycleOrderList.some((r) => r.cupboardType === "customize"));
    }
    function Z() {
      return g(this, null, function* () {
        var a;
        try {
          m.value = !0;
          const t = {
            brand: "ALL",
            category: "ALL",
            checkPoint: e.checkPoint,
            productChannel: "ALL",
            appCode: "caxa_onekey"
          }, r = yield ue(t);
          if (!(r != null && r.data) || r.data.length === 0) {
            console.error("未获取到检查项");
            return;
          }
          const o = e.cycleOrderList.filter((n) => {
            var c;
            const d = ((c = n.orderData) == null ? void 0 : c.old) === 1;
            return n.cupboardType === "customize" && !d;
          }).map((n) => {
            const d = r.data.map((_) => ({
              checkTypeId: _.id,
              checkType: _.code
            })), c = n.customizeList && n.customizeList.length > 0 ? n.customizeList[0] : { caseName: "", caseId: "", name: "" };
            return {
              brand: n.brand,
              category: n.category,
              productChannel: n.productChannel,
              designerId: e.designerId,
              designerAccount: e.designerAccount,
              caseId: c.caseId,
              caseName: c.caseName,
              productId: n.cupboardId,
              productName: c.name,
              checkPointType: "YiJianXiaDan",
              checkTypes: d,
              fileUrlList: n.splitOrderFileList || []
            };
          });
          if (!o.length) {
            console.log("无定制品订单，无需周期检查");
            return;
          }
          const s = {
            pageNum: 1,
            pageSize: 10,
            sourceKey: e.sourceKey || "",
            checkSync: !1,
            list: o
          }, l = yield ye(s);
          console.log("周期检查结果:", l), e.businessType === "BATCH_ID" && (e.businessId = ((a = l == null ? void 0 : l.data) == null ? void 0 : a.batchId) || "");
        } catch (t) {
          console.error("周期检查失败:", t);
        } finally {
          m.value = !1;
        }
      });
    }
    function W() {
      return g(this, null, function* () {
        try {
          m.value = !0, u.value = !0, console.log("formParams.cycleOrderList", e.cycleOrderList);
          const a = e.cycleOrderList.map(
            (s) => {
              const l = s.orderData || {}, n = s.standardList ? s.standardList.map((c) => c.productId) : [], d = {
                cupboardId: s.cupboardId,
                cupboardType: s.cupboardType,
                productCategory: l.productCategory || "",
                commodityIdList: n
              };
              return e.businessType === "ORDER_ID" && (d.orderId = s.orderId || ""), d;
            }
          );
          if (e.businessType === "BATCH_ID" && e.businessId && a.push({
            batchId: e.businessId || ""
          }), a.length === 0) {
            console.error("订单周期请求参数不能为空");
            return;
          }
          const t = 2e3;
          let r = 0;
          const o = () => g(this, null, function* () {
            if (!u.value) {
              console.log("轮询已被取消");
              return;
            }
            r++;
            const s = yield ie(a);
            if (s != null && s.data) {
              const l = s.data.status;
              l === 1 ? (ee(s), console.log("订单周期获取完成")) : l === 2 ? (console.error("订单周期获取失败"), e.businessType === "BATCH_ID" && (e.businessId = "")) : l === 0 ? (console.log(`订单周期执行中，继续轮询 (第 ${r} 次)`), yield new Promise((n) => setTimeout(n, t)), u.value ? yield o() : console.log("轮询已被取消")) : (console.error("未知状态，当作完成处理"), e.businessType === "BATCH_ID" && (e.businessId = ""));
            }
          });
          yield o();
        } catch (a) {
          console.error("获取订单周期失败:", a);
        } finally {
          m.value = !1, u.value = !1;
        }
      });
    }
    function ee(a) {
      a != null && a.data && (e.totalStorageDayNumber = a.data.totalStorageDayNumber == null ? null : parseInt(a.data.totalStorageDayNumber), a.data.orderStorageTimeList && a.data.orderStorageTimeList.length > 0 && a.data.orderStorageTimeList.forEach((t) => {
        const r = e.cycleOrderList.find(
          (o) => o.cupboardId === t.cupboardId
        );
        r && (r.storageDayNumber = t.storageDayNumber);
      }));
    }
    function te(a, t) {
      return g(this, null, function* () {
        a && Object.assign(e, a), t != null && t.zIndex && (p.value = t.zIndex), P.value = !!(t != null && t.disabledViewDetails), D.value = !0;
        const r = X();
        return console.log("订单周期完整性检查结果:", r), !r && e.isNeedCycleCheck && (yield Z()), !r && (yield W()), new Promise((o) => {
          e._resolve = o;
        });
      });
    }
    function re(a) {
      if (console.log("查看明细:", a), !C.value) {
        console.error("deliveryDetails 组件未加载");
        return;
      }
      const t = {
        businessType: e.businessType,
        businessId: "",
        cupboardIdList: []
      };
      if (e.businessType === "BATCH_ID" && !e.businessId) {
        console.error("批次ID场景下，businessId 不能为空");
        return;
      }
      e.businessType === "BATCH_ID" ? (t.businessId = e.businessId || "", t.cupboardIdList = [a.cupboardId]) : e.businessType === "ORDER_ID" && (t.businessId = a.orderId || ""), C.value.open(t, {
        zIndex: p.value + 10
        // 让交期明细的 zIndex 比订单周期弹窗高
      });
    }
    function ae(a) {
      e.customerDeliveryDate = a, e.cycleOrderList.forEach((t) => {
        t.orderDeliveryDate = a;
      });
    }
    function se(a, t) {
      const r = e.cycleOrderList.find((o) => o.cupboardId === a);
      r && (r.orderDeliveryDate = t);
    }
    function oe() {
      const a = z(), t = e.cycleOrderList.some((s) => {
        var d;
        const n = ((d = s.orderData) == null ? void 0 : d.old) === 1 ? 0 : 4;
        return !F(s.orderDeliveryDate, s.storageDayNumber, n);
      });
      if (a || t) {
        L.warning("存在不符合周期的数据");
        return;
      }
      const r = e._resolve, o = {
        customerDeliveryDate: e.customerDeliveryDate,
        batchId: e.businessId,
        cycleOrderList: e.cycleOrderList
      };
      r && (r(o), delete e._resolve), N();
    }
    const N = () => {
      u.value && (u.value = !1, console.log("关闭弹窗，取消轮询"));
      const a = e._resolve;
      a && (a(void 0), delete e._resolve), D.value = !1;
    };
    return x({ open: te }), (a, t) => (y(), v(R, null, [
      i("div", {
        ref_key: "orderCycleContainer",
        ref: f
      }, null, 512),
      w(ne, {
        ref_key: "deliveryDetailsRef",
        ref: C
      }, null, 512),
      w(I(we), {
        bordered: "",
        show: D.value,
        "onUpdate:show": t[1] || (t[1] = (r) => D.value = r),
        "mask-closable": !1,
        "z-index": p.value,
        to: f.value || "body",
        class: "tw:!w-[75%]"
      }, {
        default: h(() => [
          w(I(De), {
            title: "工厂交货周期",
            bordered: !1,
            role: "dialog",
            closable: "",
            onClose: N
          }, {
            default: h(() => [
              w(I(ge), { show: m.value }, {
                default: h(() => [
                  i("div", Ie, [
                    i("div", Ce, [
                      i("span", _e, "最长工厂交货周期：" + T(e.totalStorageDayNumber != null ? e.totalStorageDayNumber : "--") + " 天", 1),
                      e.totalStorageDayNumber != null && e.totalStorageDayNumber <= 15 ? (y(), v("span", he, "*当前方案属于10天交付材料范围（扣款→发货）")) : A("", !0),
                      t[2] || (t[2] = i("span", { class: "tw:mr-2 tw:font-bold" }, "客户期望交期", -1)),
                      w(I(ve), {
                        value: e.customerDeliveryDate,
                        "onUpdate:value": t[0] || (t[0] = (r) => e.customerDeliveryDate = r),
                        type: "date",
                        format: "yyyy-MM-dd",
                        class: "tw:w-[200px]",
                        "is-date-disabled": O.value ? () => !1 : J.value,
                        "on-update:value": ae,
                        to: !1,
                        disabled: O.value
                      }, null, 8, ["value", "is-date-disabled", "disabled"]),
                      !O.value && z() ? (y(), v("div", Le, " 不符合交期 ")) : A("", !0)
                    ]),
                    t[3] || (t[3] = i("div", { class: "tw:text-xs tw:text-red-500" }, " （最长工厂交货周期适用订单范围:橱衣木卫定制品/小样品/卫浴标准柜，且非遗留订单） ", -1))
                  ]),
                  i("div", Oe, [
                    (y(!0), v(R, null, j(q.value, (r) => (y(), v("div", {
                      key: r.brandCategory,
                      class: "tw:mb-4 last:tw:mb-0"
                    }, [
                      i("div", Te, [
                        i("span", xe, T(r.brandLabel) + "-" + T(r.categoryLabel), 1),
                        i("span", Ne, T(r.items.length), 1)
                      ]),
                      (y(!0), v(R, null, j(r.items, (o, s) => (y(), Q(le, {
                        key: s,
                        item: o,
                        pageMode: e.pageMode,
                        onViewDetails: re,
                        onDateChange: se,
                        class: "tw:mb-3",
                        disabledViewDetails: P.value
                      }, null, 8, ["item", "pageMode", "disabledViewDetails"]))), 128))
                    ]))), 128))
                  ]),
                  i("div", ke, [
                    w(I(G), { onClick: N }, {
                      default: h(() => t[4] || (t[4] = [
                        K("取消", -1)
                      ])),
                      _: 1,
                      __: [4]
                    }),
                    O.value ? A("", !0) : (y(), Q(I(G), {
                      key: 0,
                      type: "primary",
                      onClick: oe
                    }, {
                      default: h(() => t[5] || (t[5] = [
                        K("确定", -1)
                      ])),
                      _: 1,
                      __: [5]
                    }))
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show", "z-index", "to"])
    ], 64));
  }
});
export {
  Je as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/order-cycle/OrderCycleContent.vue.js
// module id = 1272
// module chunks = 41